import { apiAuthHeaders } from '../../core/api.js';
import { getIsOwnerApp } from '../../app/app-state.js';

export function initOwnerChatPingStat() {
  if (!getIsOwnerApp()) return;
  const pingEl = document.getElementById('owner-chat-ping-stat');
  if (!pingEl) return;
  const statEl = pingEl;
  try {
    statEl.removeAttribute('hidden');
  } catch (_) {}
  try {
    if (statEl.parentElement && statEl.parentElement !== document.body) {
      document.body.appendChild(statEl);
    }
  } catch (_) {}

  let iv: ReturnType<typeof setInterval> | null = null;
  var stopped = false;
  var busy = false;

  function setState(text: string, kind: string) {
    statEl.textContent = text;
    statEl.classList.remove('is-good', 'is-warn', 'is-bad');
    if (kind) statEl.classList.add(kind);
  }

  function classify(ms: number) {
    if (ms <= 220) return 'is-good';
    if (ms <= 650) return 'is-warn';
    return 'is-bad';
  }

  function probe() {
    if (stopped || busy) return;
    busy = true;
    var started =
      window.performance && typeof performance.now === 'function' ? performance.now() : Date.now();
    fetch('/health', { cache: 'no-store', headers: apiAuthHeaders() })
      .then(function (res) {
        if (!res.ok) throw new Error('bad status');
        var ended =
          window.performance && typeof performance.now === 'function' ? performance.now() : Date.now();
        var ping = Math.max(1, Math.round(ended - started));
        setState(String(ping) + 'мс', classify(ping));
      })
      .catch(function () {
        setState('—', 'is-bad');
      })
      .then(function () {
        busy = false;
      });
  }

  setState('…', '');
  probe();
  iv = setInterval(probe, 1000);

  window.addEventListener('beforeunload', function () {
    stopped = true;
    if (iv) {
      try {
        clearInterval(iv);
      } catch (_) {}
      iv = null;
    }
  });
}
